export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["表单字段编号"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["缺少所需的 ID"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您已成功登录，请继续ATM操作"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["继续 ATM 交易"])}
}